import { useEffect, useState } from "react";
import { toast } from "sonner";
import { api, formatApiError } from "../lib/api";
import { Button } from "./ui/button";
import { Input } from "./ui/input";
import { Label } from "./ui/label";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from "./ui/dialog";

const today = () => new Date().toLocaleDateString("en-CA");

const endDate = (start) => {
  const d = new Date(`${start}T00:00:00`);
  d.setDate(d.getDate() + 30);
  return d.toLocaleDateString("pt-BR");
};

export const ManualActivateDialog = ({ user, onClose, onDone }) => {
  const [start, setStart] = useState(today());
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    if (user) { setStart(today()); }
  }, [user]);

  const submit = async () => {
    setSaving(true);
    try {
      await api.post(`/admin/users/${user.id}/manual-activate`, { plan: "plan_associado", start_date: start });
      toast.success(`Plano ativado para ${user.name}`);
      onDone();
      onClose();
    } catch (e) { toast.error(formatApiError(e)); }
    finally { setSaving(false); }
  };

  return (
    <Dialog open={!!user} onOpenChange={(o) => !o && onClose()}>
      <DialogContent data-testid="manual-activate-dialog">
        <DialogHeader>
          <DialogTitle>Ativar plano manualmente</DialogTitle>
        </DialogHeader>
        {user && (
          <div className="space-y-4">
            <p className="text-sm text-muted-foreground">
              {user.name} — sem pagamento. As comissões da rede acima são pagas normalmente.
            </p>
            <div className="space-y-1">
              <Label>Plano</Label>
              <div className="p-2 rounded-lg border border-border text-sm" data-testid="manual-plan">Associado Ativo — R$ 39,90</div>
            </div>
            <div className="space-y-1">
              <Label>Início do ciclo de 30 dias</Label>
              <Input type="date" value={start} onChange={(e) => setStart(e.target.value)} data-testid="manual-start-date" />
              {start && <p className="text-xs text-muted-foreground" data-testid="manual-end-date">Vence em {endDate(start)}</p>}
            </div>
          </div>
        )}
        <DialogFooter>
          <Button variant="outline" onClick={onClose} data-testid="manual-cancel-btn">Cancelar</Button>
          <Button className="gold-btn" disabled={!start || saving} onClick={submit} data-testid="manual-confirm-btn">
            {saving ? "Ativando..." : "Ativar plano"}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
